type ApiErrorBody = {
  message?: string;
  code?: string;
};

export class FetchJsonResponseParser {
  private static getHttpErrorMessage(res: Response, rawBody: string, data?: unknown): string {
    if (data && typeof data === 'object' && 'message' in data) {
      const { message } = data as ApiErrorBody;
      if (typeof message === 'string' && message) {
        return message;
      }
    }

    if (rawBody && !rawBody.startsWith('<')) {
      return rawBody;
    }

    return `Request failed with status ${res.status}`;
  }

  static async parse<T>(res: Response): Promise<T> {
    const rawBody = await res.text();
    const trimmedBody = rawBody.trim();
    let data: unknown;

    if (trimmedBody) {
      try {
        data = JSON.parse(trimmedBody);
      } catch {
        if (!res.ok) {
          throw new Error(FetchJsonResponseParser.getHttpErrorMessage(res, trimmedBody));
        }
        throw new Error('Invalid JSON response from server');
      }
    }

    if (!res.ok) {
      throw new Error(FetchJsonResponseParser.getHttpErrorMessage(res, trimmedBody, data));
    }

    if (!trimmedBody) {
      throw new Error(`Empty response from server (status ${res.status})`);
    }

    return data as T;
  }
}
